import React from "react";

const AppML_Controllers = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Controllers</h1>
      <p>This is the AppML Controllers page content.</p>
    </div>
  );
};

export default AppML_Controllers;
